import { RequestBuilder } from "../requestBuilder";
import {
  CreateAssetInputSchema,
  UpdateAssetInputSchema,
  AssetIdParamsSchema,
  AssetsSyncSchema,
  CreateAssetHttpInputSchema,
  CreateAssetHttpResponseSchema,
  UploadCompleteParamsSchema,
  GetAssetsRequestSchema,
  GetAssetsResponseSchema,
  MoveAssetsRequestSchema,
} from "./assetClient.types";
import { AssetSchema, AssetSignedUrlSchema } from "@storytell/types";

export const AssetsSyncRequestConfig = new RequestBuilder({
  path: () => "/assets-sync",
  responseSchema: AssetsSyncSchema,
});

export const CreateAssetRequestConfig = new RequestBuilder({
  path: () => "/assets",
  responseSchema: AssetSchema,
  bodySchema: CreateAssetInputSchema,
}).withMethod("POST");

export const DeleteAssetRequestConfig = new RequestBuilder({
  paramsSchema: AssetIdParamsSchema,
  path: (params) => `/assets/${params.id}`,
})
  .withMethod("DELETE")
  .withContentType(undefined);

export const UpdateAssetRequestConfig = new RequestBuilder({
  paramsSchema: AssetIdParamsSchema,
  path: ({ id }) => `/assets/${id}`,
  responseSchema: AssetSchema,
  bodySchema: UpdateAssetInputSchema,
}).withMethod("POST");

// HTTP API for file upload flow
export const CreateAssetHttpRequestConfig = new RequestBuilder({
  path: () => "/assets",
  responseSchema: CreateAssetHttpResponseSchema,
  bodySchema: CreateAssetHttpInputSchema,
}).withMethod("POST");

export const UploadCompleteRequestConfig = new RequestBuilder({
  paramsSchema: UploadCompleteParamsSchema,
  path: (params) => `/assets/${params.assetId}/uploaded`,
  responseSchema: AssetSchema,
}).withMethod("PUT");

export const GetAssetsRequestConfig = new RequestBuilder({
  path: () => "/assets/bulk",
  responseSchema: GetAssetsResponseSchema,
  bodySchema: GetAssetsRequestSchema,
}).withMethod("POST");

export const GenerateSignedUrlRequestConfig = new RequestBuilder({
  paramsSchema: AssetIdParamsSchema,
  path: (params) => `/assets/${params.id}/download`,
  responseSchema: AssetSignedUrlSchema,
}).withMethod("GET");

export const MoveAssetsRequestConfig = new RequestBuilder({
  path: () => "/assets-move",
  bodySchema: MoveAssetsRequestSchema,
})
  .withMethod("POST")
  .withContentType(undefined);
